import React, { useState , useEffect} from 'react'
import { Link } from 'react-router-dom';
import useLogout from '../../hooks/useLogout';
import logoCIE from '../../assets/img/logoCIE.svg'; 
import btnLogout2 from '../../assets/img/btnLogout2.svg';
import btnHome2 from '../../assets/img/btnHome2.svg';
import btnLevels6 from '../../assets/img/btnLevels6.svg';
import btnMenu from '../../assets/img/btnMenu.png';
import btnLista from '../../assets/img/btnLista.png';


export default function HeaderAdmin() {
  const [menuExpanded, setMenuExpanded] = useState(false);
  const [user, setUser] = useState(null);
  const logout = useLogout();

  useEffect(() => {
    const userStr = localStorage.getItem('usuario');
    if (userStr) {
      setUser(JSON.parse(userStr));
    }
  }, []);

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="flex justify-between items-center p-2">
      <img src={logoCIE} alt="Logo CIE" className="w-auto h-10" />
      <div className="flex items-center">
        {menuExpanded && (
          
          <div className="flex items-center mr-2">
            
            <Link to="/niveles" className="mr-2 ml-2">
              <img src={btnLevels6} alt="Niveles" className="w-12 h-auto" />
            </Link>

            {user && user.rol === "Administrativo" && (
              <Link to="/admin/lista-usuarios">
                <img src={btnLista} alt="Lista de usuarios" className="w-12 h-auto" />
              </Link>
            )}

            {user && user.rol === "Administrador" && (
              <Link to="/admin-panel">
                <img src={btnHome2} alt="Inicio" className="w-12 h-auto" />
              </Link>
            )}

            

            <button onClick={handleLogout} className="bg-transparent border-none cursor-pointer mr-2 ml-2">
              <img src={btnLogout2} alt="Cerrar sesión" className="w-12 h-auto" />
            </button>
          </div>
        )}
        <button
          onClick={() => setMenuExpanded(!menuExpanded)}
          className="focus:outline-none"
        >
          <img
            src={btnMenu}
            alt="Menu"
            className="w-12 h-auto"
          />
        </button>
      </div>
    </div>
  )
}